export default __webpack_public_path__ + "static/media/SRVI.e2225657.png";